// standard message strings

export const MSG_ACK_ABOVE = 'I acknowledge the above.';
export const MSG_ACKNOWLEDGE_FEE_1 = "Please acknowledge amendment fee of $60";
export const MSG_ACKNOWLEDGE_FEE_2 = ", thank you.";
export const MSG_INSPECTOR_AGREE = "I hereby confirm that I had review and upload all supporting documents (if any) under this application.";
export const MSG_ACRA_VALIDITY = "ACRA Submitted should be within 6 months.";
export const MSG_KINDLY_REVIEW = "Kindly review and confirm that all submitted and provided information is accurate and complete.";
export const MSG_NOTE_CHARGES = "Please note that any changes or edits requested after confirmation may incur additional charges.";    
export const MSG_TERMINATE_DISCLAIMER_LINES = [
"Dear client,",
"We acknowledge receipt of your termination request.", 
"As we have already started reviewing your application, please note that an administrative review fee ($380) and a document review fee ($200) will be applicable as part of the termination process.",
"Thank you for your understanding.",
];

export const MSG_FINALCONFIRM_1 = "I hereby confirm that all submitted and provided information are accurate and complete.";
export const MSG_FINALCONFIRM_2 = "I hereby confirm that I have reviewed and understood the applicable terms and conditions"
export const MSG_FINALCONFIRM_LINK = "https://www.setsco.com/services/certification/";